import frame1 from "./assets/frame1.png";
import frame2 from "./assets/frame2.png";
import frame3 from "./assets/frame3.png";
import frame4 from "./assets/frame4.png";
import vivek from "./assets/profiles/vivek.webp";
import srikant from "./assets/profiles/srikant.webp";
import andrew from "./assets/profiles/andrew.png";
import lion from "./assets/profiles/Lion.png";
import stephan from "./assets/profiles/stephan.png";
import lucas from "./assets/profiles/lucas.png";
import devansh from "./assets/profiles/devansh.webp";
import krishna from "./assets/profiles/krishna.webp";
import i1 from "./assets/i1.png";
import f1 from "./assets/f1.png";
import t1 from "./assets/t1.png";
import y1 from "./assets/y1.png";
import l1 from "./assets/l1.png";
import s1 from "./assets/s1.png";
import s2 from "./assets/s2.png";
import t11 from "./assets/t11.webp";
import t2 from "./assets/t2.webp";
import t3 from "./assets/t3.webp";
import ss1 from "./assets/tutorials/ss1.webp";
import ss2 from "./assets/tutorials/ss2.webp";
import ss3 from "./assets/tutorials/ss3.webp";
import ss4 from "./assets/tutorials/ss4.webp";
import ss5 from "./assets/tutorials/ss5.webp";
import ss6 from "./assets/tutorials/ss6.webp";
import ss7 from "./assets/tutorials/ss7.webp";
import ss8 from "./assets/tutorials/ss8.webp";
import ss9 from "./assets/tutorials/ss9.webp";
import ss10 from "./assets/tutorials/ss10.webp";
import ss11 from "./assets/tutorials/ss11.webp";
import ss12 from "./assets/tutorials/ss12.webp";
import ss13 from "./assets/tutorials/ss13.webp";
import ss14 from "./assets/tutorials/ss14.webp";
import ss15 from "./assets/tutorials/ss15.webp";
import ss16 from "./assets/tutorials/ss16.webp";
import ss17 from "./assets/tutorials/ss17.webp";
import ss18 from "./assets/tutorials/ss18.webp";
import ss19 from "./assets/tutorials/ss19.webp";
import music1 from "./assets/cinematic.mp3";
import music2 from "./assets/indian.mp3";
import music3 from "./assets/electronic.mp3";
import music4 from "./assets/indie.mp3";
import cover from "./assets/Cover.webp";
import cover1 from "./assets/Cover1.webp";
import cover2 from "./assets/Cover2.webp";
import cover3 from "./assets/Cover3.webp";
import RollingStone from "./assets/featured/Rolling-Stones.png";
import Billboard from "../src/assets/featured/Billboard.png";
import TechCrunch from "../src/assets/featured/TechCrunch.png";
import Washington from "../src/assets/featured/washington.png";
import FastCompany from "../src/assets/featured/fastc.png";
import forbes from "../src/assets/featured/forbes.svg";
import bbc from "../src/assets/featured/bbc.svg";
import harvard from "../src/assets/featured/harvard.svg";
import andressen from "../src/assets/featured/andressen.svg"
import ade from "../src/assets/featured/ade.svg";

export const homeData = [
  {
    img: frame1,
    heading: "Pick a Genre/Style",
    content:
      "Upload a video/podcast or start with a track. Choose from 8 different Genres to suit your theme.",
  },
  {
    img: frame2,
    heading: "Make some cuts",
    content:
      "We know that the mood in the content changes over time. That’s why you can make multiple cuts to add different moods.",
  },
  {
    img: frame3,
    heading: "Change Mood",
    content:
      "Now, choose from a rich selection of 16 moods to choose the correct mood for the cuts.",
  },
  {
    img: frame4,
    heading: "Compose",
    content:
      "Hit compose and let our AI do all the hard work of composing a unique track for you.",
  },
];

export default function getImage(name) {
  switch (name) {
    case "Facebook":
      return f1;
    case "Instagram":
      return i1;
    case "Twitter":
      return t1;
    case "Youtube":
      return y1;
    case "Linkedin":
      return l1;
    case "Spotify":
      return s1;
    case "Soundcloud":
      return s2;
    default:
      return null;
  }
}

export const testimonials1 = [
  {
    name: "Lion El Aton",
    text: "“Beatoven.ai revolutionizes AI music—innovative platform, artist-friendly pay. Crafting film-worthy music in minutes is mind-blowing, just the start of their groundbreaking innovation.”",
    designation: "Founder @FILMCRUX",
    img: lion,
  },
  {
    name: "Andrew Creskey",
    text: "“It’s an innovative tool to make unique tracks for my latest game. The music perfectly captures the theme of my game for an immersive experience. My go to platform for my next game!”",
    designation: "Game Developer",
    img: andrew,
  },
  {
    name: "Stefan Thomas",
    text: "“I love how beatoven.ai makes it simple, quick and inexpensive for me to create the perfect backing track for each video and montage.”",
    designation: "Business coach/ Keynote speaker",
    img: stephan,
  },
  {
    name: "Lucas Brasier ",
    text: "“A game changer for content creators! Beatoven.ai saves me time and helps in monetising my videos without any trouble. Highly recommended for creators who are on the lookout for good music!”",
    designation: "Youtuber",
    img: lucas,
  },
];
export const testimonials2 = [
  {
    name: "Devansh Doshi",
    text: "“This is an exciting interface and a very ambitious product.”",
    designation: "Ad Agency Owner",
    img: devansh,
  },
  {
    name: "Krishna Devate ",
    text: "“Biggest advantage is Indian tracks.”",
    designation: "CEO Hustler & Monk Productions",
    img: krishna,
  },
];

export const usecases = [
  {
    id: "1",
    tag: "agencies",
    heading: "Agency/ Production House",
    title:" AI generated music for video production",
    description : "",
    desc: [
      {
        link: " Pack a serious punch with your videos.",
        text: "From regional to indie music, generated tracks for your taste, which saves you the time spent searching in large libraries.",
      },
      {
        link: "Make explainer videos gripping.",
        text: "Enhance your voiceover in tutorials, with background music. Adjust the volume of your sections to make your conversations sound distinct while the music continues.",
      },
      {
        link: "Set the pace in your ads.",
        text: "With control on tempo, you can choose 3 categories of pace in your music. Elevate your video production experience with tempo adjustments.",
      },
    ],
    videoLink: "https://youtu.be/voeWQxBHRiY",
  },
  {
    id: "2",
    tag: "youtube",
    heading: "Youtube Creators",
    title: "AI music generator for Youtube creators",
    description : "Need copyright free music for Youtube? Try beatoven.ai to generate royalty free music for Youtube",
    desc: [
      {
        link: "Make your channel’s signature sound",
        text: "Stand out with an audio identity for your channel, playlists, and videos.",
      },
      {
        link: "Connect with your audience in outro sections.",
        text: "Declare your upcoming projects or collaborations, and leave messages for your audience with outro music in the background.",
      },
      {
        link: "Add impact without the strain of editing and licensing music",
        text: "Beatoven’s timeline window provides for easy editing, with control on instruments and tempo. No hassles of paying royalties as it's royalty free music.",
      },
    ],
    videoLink: "https://youtu.be/hDUYgGoxrNY",
  },
  {
    id: "3",
    tag: "podcasts",
    heading: "Podcast Creators",
    title : "AI podcast music generator for podcast creators",
    description : "Looking for podcast theme song generator to create original Intro and outro music for your podcast? Try out this ai music generator for creators of podcast and other audio content.",
    desc: [
      {
        link: "Make intro sections special",
        text: "Welcome new and old listeners with impact, using royalty-free music created by AI.",
      },
      {
        link: "Announce your sponsors in style",
        text: "Make your fillers and advertising sections feel distinct from your original material, with Cheerful mood tracks from Beatoven.",
      },
      {
        link: "End your episodes with flair",
        text: "Announce your next episodes or collaborators with our “triumphant” mood music.",
      },
    ],
    videoLink: "https://youtu.be/qc30CFlP7kw",
  },
  {
    id: "4",
    tag: "indie-game-dev",
    heading: "Indie Game Developers",
    title : " AI game music generator for game creators",
    description : "Looking for original music for indie games? Try Beatoven.ai, an AI video game music generator for independent game creators",
    desc: [
      {
        link: "Design themes for levels",
        text: "Every level can feel different, with the right music. Use combinations of moods and genres to convey criticality in any mission.",
      },
      {
        link: "Background music for scenarios and characters",
        text: "Depending on the circumstance and action on screen, keep an inventory of music ready. Whether you are solving a puzzle or building a city, there is a right tune for each situation.",
      },
      {
        link: "Make music for menu screens in your game",
        text: "Have the players groove to a signature tune that will stay with them, as they check out the settings, controls, etc.",
      },
    ],
    videoLink: "https://youtu.be/YO2qn18DoWQ",
  },
  {
    id: "5",
    tag: "audio-books",
    heading: "Audio books",
    title : "Royalty free AI music generator for Audio-books",
    desc: [
      {
        link: "Elevate your stories by creating atmosphere",
        text: "With the cinematic genre, establish the tone for your chapters, ranging from suspense to comedy.",
      },
      {
        link: "Dramatise moments with ambient music",
        text: "Add anticipation and hope in your stories with ambient genre music. Make poetry beautiful with the mood and genre of your choice.",
      },
      {
        link: "No more abrupt breaks between chapters",
        text: "Make filler tracks to carry the audience from one chapter to the next. Maintain their attention with the right transition music created by AI.",
      },
    ],
    videoLink: "https://youtu.be/-ccTjjF8xsI",
  },
  {
    id: "6",
    tag: "web3-metaverse",
    heading: "Web3 & Metaverse Companies",
    title : "Royalty free AI music generator for Metaverse",
    desc: [
      {
        link: "Background music for metaverse games",
        text: "Design environments and atmospheres with a characteristic soundtrack. According to situation, pick a genre and mood of your choice, and prepare a memorable experience for players.",
      },
      {
        link: "Virtual work meeting spaces and lounges",
        text: "Operating a metaverse space for working together? Engage your teammates and guests with different types of music for different meeting rooms, ideation sessions, design sprints, town halls, etc.",
      },
      {
        link: "VR experiences, from travel to entertainment",
        text: "Bring your virtual reality experiences to life with the right music, for applications across healthcare, architecture, cinema, and more. Increase immersion and engagement, with granular control over music.",
      },
    ],
    videoLink: "https://youtu.be/u93E1bhxLcw",
  },
];

export const tutorials = [
  {
    id: "1",
    tag: "first-project",
    heading: "Creating my first project with Beatoven.ai",
    videoLink: "https://youtu.be/_ddUhbBOAT4",
    desc: "This article will take  you through all the steps in creating your first masterpiece using Beatoven.ai",
    s1: "Welcome to the future of music creation. To make your first project with Beatoven, login to the platform using your email address and password.",
    about: [
      {
        step: "Step 1",
        img1: ss1,
        desc1:
          "Depending on the content you want to generate music for, you can choose one of three options:",
        links: [
          { link: "I have a video (Supported formats: mp4, avi)" },
          { link: " I have a podcast (Supported formats: mp3, wav) " },
          { link: "I just want to make a track " },
        ],
        desc2:
          "You will be asked to enter the length of track you want to create",
      },
      {
        step: "Step 2",
        img1: ss2,
        desc1:
          "Select the genre and mood to convey in your track. You can listen to examples of genres and moods by hovering over the panels.",
      },
      {
        step: "Step 3",
        img1: ss3,
        desc1:
          "While the tool finds the best samples for your demand, and mixes them, make sure to not close the window or progress circle.",
      },
      {
        step: "Step 4",
        img1: ss4,
        desc1:
          "Edit the track - you can mark sections to change the music, remove or add instruments, and change volume or tempo.",
      },
      {
        step: "Step 5",
        img1: ss5,
        desc1:
          "Save and download the track by clicking the button on the upper right corner. The downloading takes place after composition is complete.",
        desc2:
          "The track will be downloaded, and will also be available with a self-generated name you can change. You can open the track again for more editing or downloading it another time.",
      },
    ],
    cta: {
      heading: "Create your first project",
      paragraph: "Sign up for free and create your first track!",
      button: "Get Started",
    },
  },
  {
    id: "2",
    tag: "workspace-and-first-generation",
    heading: "Workspace, Projects and First Generation",
    videoLink: "https://youtu.be/7JOKEFaI34U",
    desc: "This article will take you through the basics of setting up your workspace, creating a new project, and generating your first music track.",
    s1: "Beatoven stores and manages your created music in the workspace, where you can see the names of tracks, their duration, and when they were composed. The visual also tells you which mood the track starts with.",
    about: [
      {
        step: "Step 1",
        img1: ss6,
        desc2:
          "If you want to work on an existing project, simply click on its thumbnail. The timeline view will open, where you can edit or re-compose the track.",
      },
      {
        step: "Step 2",
        img1: ss7,
        desc2:
          "To start a new project, you can add your content - drag and drop it into the right half of the screen. You can also begin a new project by clicking on “new track” in the upper right corner. This will lead you to the options for creating tracks - with video, with podcast, or a standalone track.",
      },
      {
        step: "Step 3",
        img1: ss8,
        desc2:
          "Beatoven automatically names your projects, which you can rename in the workspace or from inside the editing window.",
        desc3:
          "Your changes are auto-saved by Beatoven, after which the file is available in the workspace. ",
      },
    ],
    cta: {
      heading: "Create your first project",
      paragraph: "Sign up for free and create your first track!",
      button: "Get Started",
    },
  },
  {
    id: "3",
    tag: "mood-based-music",
    heading: "Create mood based music with Beatoven.ai",
    videoLink: "https://youtu.be/MvIk6sUC8fk",
    desc: "The mood is everything! Learn to take full advantage of the 16 vibrant moods to take your content to the next level.",
    s1: "Beatoven generates customised music to make your content stunning. By taking your inputs on what genre to compose and which mood to convey, our engine produces music that can be edited further.",
    about: [
      {
        step: "Step 1",
        img1: ss9,
        desc2:
          "In the workspace, click “new track” under “My Projects” or choose the “Click or drop your video/podcast here” on the right half of the screen.",
      },
      {
        step: "Step 2",
        img1: ss10,
        desc2:
          "In the next step, you will be asked “Which genre or regional sound do you want your track to have?”. This is where you choose 1 out of 8 genres of music, which you can preview by hovering the mouse pointer over the panels.",
      },
      {
        step: "Step 3",
        img1: ss11,
        desc2:
          "Out of the 16 moods the tool can convey, you will be asked to choose one in the next window. Below “What emotion do you want to assign to this track?”, there will be a grid of these moods which you can preview by hovering over the panels.",
        desc3:
          "While the music is being composed, closing the tab can cause loss of progress. Once it’s complete, you can find the composed music on the timeline below, and begin your editing process.  ",
      },
    ],
    cta: {
      heading: "What are you in the mood for?",
      paragraph:
        "Create unlimited tracks with unique moods to elevate your content",
      button: "Get Started",
    },
  },
  {
    id: "4",
    tag: "instrument-selection",
    heading: "Selecting and deselecting instruments in my composition",
    videoLink: "https://youtu.be/qqj_FBHKRuw",
    desc: "Instruments can make a big difference to the music track. Learn how to customize each section by turning on/off instruments.",
    s1: "Beatoven’s compositions have various instruments, depending on the genre selected. The tool offers the option to select which exact instruments to be added or removed from the track.",
    about: [
      {
        step: "Step 1",
        img1: ss12,
        desc2:
          "In the bottom right corner below the timeline, you will find a piano icon. Hover over it, and you will see the message “Select instruments for this section”.",
      },
      {
        step: "Step 2",
        img1: ss13,
        desc2:
          "By toggling, you can select which instruments you want to keep.",
      },
      {
        step: "Step 3",
        img1: ss14,
        desc2:
          "In some cases, an instrument might be more critical to the composition, and removing it can make the section sound less intensive. Select the right mood and genre to your taste, so that instrument selection works as intended.",
      },
    ],
    cta: {
      heading: "Explore genre and instruments",
      paragraph:
        "Create unlimited tracks with unique moods to elevate your content",
      button: "Get Started",
    },
  },
  {
    id: "5",
    tag: "section-preferences",
    heading: "Section preferences using Beatoven.ai’s sample swap feature",
    videoLink: "https://youtu.be/2suXkxe7vjw",
    desc: "Choose to how to choose between 5 music track options for each section. More choices, more control.",
    s1: "Beatoven provides features to elevate different parts of your content with different types of music. If you want to add multiple moods inside the same track, begin with identifying the instants at which you want the changes to happen.",
    about: [
      {
        step: "Step 1",
        img1: ss15,
        desc2:
          "Next, use the scissor icon to mark sections. You can zoom in or out of the timeline too, using the slider next to the magnifying glass.",
      },
      {
        step: "Step 2",
        img1: ss16,
        desc2:
          "Once you have the sections marked, alter the mood by selecting the area on the bottom left where the current mood is shown.",
      },
      {
        step: "Step 3",
        img1: ss17,
        desc2: "Select the mood you want to change to, and re-compose.",
      },
      {
        step: "Step 4",
        img1: ss18,
        desc2:
          "If you want to change the section’s original composition altogether, you can also view available alternatives from the waveform button. Five alternative compositions will be listed, that you can preview.",
      },
      {
        step: "Step 5",
        img1: ss19,
        desc2:
          "Once you select something you like, re-compose the track and save your changes.",
      },
    ],
    cta: {
      heading: "Add multiple moods with sections",
      paragraph:
        "Create unlimited tracks with unique moods to elevate your content",
      button: "Get Started",
    },
  },
];

export const FAQs = [
  {
    id: 1,
    heading: "What are the licensing terms for the music?",
    desc: "The users will be granted a perpetual license for usage of the soundtracks on their choice of use case. All copyrights for the musical works created on Beatoven belong to the company.",
    open: true,
  },
  {
    id: 2,
    heading: "How can I use the music created on beatoven.ai?",
    desc: "You can use the music created on beatoven.ai for any of your",
    list: [
      {
        name: "Video content (youtube)",
        link: "https://www.youtube.com/watch?v=X6Ocu-f6jI0",
      },
      { name: "Podcasts", link: "https://www.youtube.com/watch?v=pMRqTAVze8A" },
      { name: "Games ", link: "https://luisfmp.itch.io/platmat" },
      {
        name: "Short films/Trailers ",
        link: "https://www.youtube.com/watch?v=-eVb7OCuJXo",
      },
      {
        name: "Social media ",
        link: "https://www.instagram.com/reel/CkaqnWTrAGY/?igshid=MzRlODBiNWFlZA==",
      },
      { name: "AI art ", link: "https://www.youtube.com/watch?v=piiCLiKIiYw" },
      {
        name: "Advertisements ",
        link: "https://www.linkedin.com/posts/michael-skarbek_my-last-post-talked-about-the-limitations-activity-7025245324206112768--x3T?utm_source=share&utm_medium=member_ios",
      },
      {
        name: "Livestreams",
        link: "https://www.youtube.com/watch?v=q6ieJFSgjLY",
      },
    ],
    open: false,
  },
  {
    id: 4,
    heading: "Will I get a copyright claim for using music from beatoven.ai?",
    desc: "No, you do not get a copyright claim on your content for using music from beatoven.ai. If you ever receive a copyright claim on your content, you can contest it using our license and write to us on hello@beatoven.ai for further help.",
    open: false,
  },
  {
    id: 5,
    heading: "Can I upload the music from beatoven.ai on Spotify?",
    desc: "No, we do not allow publishing of our tracks on music streaming platforms like Spotify, soundcloud, apple music etc.",
    open: false,
  },
  {
    id: 6,
    heading: "Can I add lyrics to the track I create on beatoven.ai?",
    desc: " We do not have the feature to add lyrics to the track you create on beatoven.ai",
    open: false,
  },
  {
    id: 7,
    heading: "Can this tool support if I have a voiceover in my video?",
    desc: "Yes. Beatoven’s volume automation parameter helps you adjust fades and silence wherever you’d like the music to be soft or louder as per your voiceover",
  },
];

export const pressData = [
  {
    title:
      "Who are Beatoven.ai? Meet India’s first and only AI-backed music tech start-up",
    desc: "Beatoven.ai is India’s first and only AI-backed, new age, web-based disruptive music tech start-up that provides a platform for music composers and content creators to help them create royalty-free, affordable, easy to license, exclusive music.",
    date: "1 month ago",
    author: "Hindustan Times",
    thumbnail: t11,
    link: "https://www.hindustantimes.com/cities/bengaluru-news/who-are-beatoven-ai-meet-india-s-first-and-only-ai-backed-music-tech-startup-101649761910476.html",
  },
  {
    title:
      "This music-tech startup uses AI to create original soundtracks, solve music acquisition problems",
    desc: "Bengaluru-based Beatoven.ai says it uses artificial intelligence (AI) to take the hassle out of composing and licensing music. ",
    date: "March 22, 2022",
    author: "YourStory",
    thumbnail: t2,
    link: "https://yourstory.com/2022/03/music-tech-startup-uses-ai--original-soundtracks-solve-music-acquisition-licensing-beatovenai/amp",
  },
  {
    title:
      "A New Tool for Podcast and Video Creators Uses AI To Readily Compose Music",
    desc: "Beatoven.ai co-founder Mansoor Rahimat Khan, also a sitarist, talks about building a bank of sounds across styles for Indian and international users",
    date: "Jan 11, 2022",
    author: "Rolling Stone",
    thumbnail: t3,
    link: "https://rollingstoneindia.com/beatoven-ai-music-for-podcast-video-creator-content/",
  },
  {
    title: "Indian startup Beatoven debuts AI-made production music",
    desc: "We’re enjoying the thinking behind Indian startup Beatoven‘s name, with its nod to Beethoven while capturing the way its service is literally (well, metaphorically) a ‘beat oven’ for its customers.",
    date: "March 14, 2022",
    author: "Musically",
    thumbnail: t11,
    link: "https://musically.com/2022/03/14/indian-startup-beatoven-debuts-ai-made-production-music/",
  },
  {
    title: "Entrepreneur First invests in 6 Indian startups",
    desc: "UK-based Entrepreneur First (EF) has backed six startups from India, the company announced at its fifth Investor Reveal Day for the country.",
    date: "Sep 28, 2021 ",
    author: "Techinasia",
    thumbnail: t2,
    link: "https://www.techinasia.com/ukbased-talent-investor-entrepreneur-invest-6-indian-startups",
  },
  {
    title: "The New Creator Economy: A guide on Web3 creator platforms",
    desc: "The power structures of the creator economy are rapidly changing - creators are now in the driver’s seat, being offered the opportunity to have greater individuality than ever before through Web3 creator platforms....",
    date: "March 30, 2022",
    author: "Antler",
    thumbnail: t3,
    link: "https://www.antler.co/blog/creatoreconomy2022",
  },
  {
    title:
      "The gradual evolution of music and the role of AI to take it to the next level",
    desc: "Music has always existed since time immemorial. There are paintings found in archaeological sites dating 40 thousand years, depicting a basic flute form. Music is considered man’s first cultural expression. Until a few decades ago, hearing music required performing musicians",
    date: "March 27, 2022",
    author: "Times Of India",
    thumbnail: t2,
    link: "https://timesofindia.indiatimes.com/blogs/voices/the-gradual-evolution-of-music-and-the-role-of-ai-to-take-it-to-the-next-level/",
  },
];
export const advisors = [
  {
    img: vivek,
    name: "Vivek Paul",
    designation:
      "Space • Entertainment • Innovations | kawa.space | anahad.ngo | fashionrevolution.org",
    social: [
      {
        link: "https://www.linkedin.com/in/vivekpaul/",
        name: "Linkedin",
      },
    ],
  },
  {
    img: srikant,
    name: "Srikant Sastri",
    designation:
      "Mentor on a Mission | Board Member/Advisor at fast-growing Companies & Universities | President TiE Delhi-NCR",
    social: [
      {
        link: "https://www.linkedin.com/in/srikantsastri1/",
        name: "Linkedin",
      },
    ],
  },
];

export const audios = [
  {
    img: cover3,
    music: music1,
    title: "Rise of the stars",
    genre: "Electronic",
  },
  {
    img: cover,
    music: music2,
    title: "Morning Raga",
    genre: "Indian",
  },
  {
    img: cover1,
    music: music3,
    title: "Bohemian sunrise",
    genre: "Indie",
  },
  {
    img: cover2,
    music: music4,
    title: "Wanderlust",
    genre: "Rock",
  },
];
export const featured = [
  {
    img: Billboard,
    link: "https://shop.billboard.com/collections/back-issues/products/august-6-2022-issue-10",
  },
  {
    img: RollingStone,
    link: "https://rollingstoneindia.com/beatoven-ai-music-for-podcast-video-creator-content/",
  },
  {
    img: TechCrunch,
    link: "https://techcrunch.com/2022/09/29/the-startup-battlefield-200-saas-enterprise-retail-and-fintech-edition/",
  },
  {
    img: Washington,
    link: "https://www.washingtonpost.com/music/2023/02/16/ai-in-classical-music/",
  },
  {
    img: FastCompany,
    link: "https://www.fastcompany.com/90856183/30-ai-tools-you-can-try-for-free",
  },
  {
    img: forbes,
    link: "https://www.forbes.com/sites/bernardmarr/2023/03/13/unleashing-the-power-of-ai-14-more-mind-blowing-tools-beyond-chatgpt/?sh=d54fb1c14e28"
  },
  {
    img: bbc,
    link: "https://www.bbc.co.uk/bitesize/articles/zxc39ty"
  },
  {
    img: harvard,
    link: "https://hbr.org/2023/02/what-young-professionals-need-to-know-about-generative-ai"
  },
  {
    img: andressen,
    link: "https://a16z.com/the-future-of-music-how-generative-ai-is-transforming-the-music-industry/"
  },
  {
    img: ade,
    link: "https://www.amsterdam-dance-event.nl/en/program/2023/which-startups-will-change-the-music-industry-with-ai-and-why/2133193/"
  }
];
